import React, { Component, useEffect, useState } from "react";
import { Link, Route } from "react-router-dom";
import Header from "../../component/frontend/Header";
import Footer from "../../component/frontend/Footer";
import SingleDepartmentView from "../../component/frontend/commonsections/SingleDepartmentView";
import { API_TOKEN_NAME, IMAGE_URL, SITE_URL } from "../../constants";
import { scAxiosAdmin } from "../..";
import icon2 from "../../images/icon-2.png";
import banner_img from "../../../public/assets/images/banner-case-study.png";
import { Helmet } from "react-helmet";
import SEO from "../../component/Seo";
import BookAppointmentPopup from "./BookAppointmentPopup";

const DepartmentsView = () => {
  const [departments, setDepartments] = useState([]);
  const [hoverId, setHoverId] = useState(null);
  const [bookAppointmentPopupClicked, setBookAppointmentPopupClicked] =
    useState(false);

  useEffect(() => {
    const getAllBannerButtonData = (data) => {
      try {
        const req = scAxiosAdmin
          .request("/department/getdepartments", {
            method: "get",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
            },
            params: {
              ...data,
            },
          })
          .then((data) => {
            if (data.status === 200) {
              setDepartments(data.data.data);
            }
          })
          .catch((e) => {
            console.log("your log output", e);
          });
      } catch (error) {}
    };
    getAllBannerButtonData();
  }, []);

  /* getAllDepartments = (data) => {
    return new Promise((resolve, reject) => {
      const req = scAxiosAdmin.request("/department/getdepartments", {
        method: "get",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
        },
        params: {
          ...data,
        },
      });
      req.then((res) => resolve(res.data)).catch((err) => reject(err));
    });
  }; */

  /* componentDidMount() {
    this.getAllDepartments().then((res) => {
      if (res.status === true) {
        var records = res.data;
        this.setState({ departments: records });
      }
      console.log(res.data);
    });
  } */

  return (
    <div>
      <SEO
        title="Department | Best Hospital in Bangladesh | United Hospital"
        description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        pathSlug="/"
        keywords="Department, departments"
      />
      <Helmet>
        <meta
          name="description"
          content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "LocalBusiness",
            name: "United Hospital Limited",
            image:
              "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
            telephone: "10666",
            email: "info@uhlbd.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "plot 15, Road 71, Gulshan",
              addressLocality: "Dhaka",
              addressRegion: "Dhaka",
              addressCountry: "Bangladesh",
              postalCode: "1212",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              opens:
                "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
            },
            url: "http://www.uhlbd.com/",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "3.9",
              bestRating: "5",
              worstRating: "1",
              ratingCount: "756",
            },
            review: {
              "@type": "Review",
              author: {
                "@type": "Person",
                name: "abdul kahar",
              },
              datePublished: "2019-02-12",
              reviewRating: {
                "@type": "Rating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
              },
              reviewBody:
                "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
            },
          })}
        </script>
        <meta
          name="Subject"
          content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
        />
        <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
        <meta name="Googlebot" content="all" />
        <meta http-equiv="imagetoolbar" content="no" />
        <meta name="robots" content="index, follow" />
        <meta name="copyright" content="Copyright &copy; uhlbd.com" />
        <meta name="owner" content="United Hospital" />
        <meta name="author" content="dcastalia.com" />
        <meta name="Rating" content="General" />
        <meta name="distribution" content="Global" />
        <meta
          name="classification"
          content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta
          names="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
        <meta name="msvalidate.01" content="16C4E0B16E39354E550F64BD707F6A97" />
      </Helmet>

      <Route component={Header} />
      <div
        id="giveMarginService"
        className=""
        style={{ backgroundColor: "#F3EFE8" }}
      >
        <section className="banner-hero ">
          <img src={banner_img} alt="banner-profile" className="w-100" />
        </section>

        <section>
          <div class="container pt-4">
            {/* <div
              className="mb-5"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                width: "82px",
                width: "100%",
                // margin: "0 auto",
              }}
            >
              <h3
                className="text-left"
                style={{
                  color: "#0C807D",
                  fontSize: "28px",
                  fontWeight: "500",
                  
                }}
              >
                Departments
              </h3>
            </div> */}
            <h3
              className="text-center mb-4"
              style={{
                color: "#AF9763",
                fontWeight: "700",
              }}
            >
              Departments
            </h3>

            <div className="row">
              {departments.map((body_department) => {
                let department_name = body_department.department_name;
                let new_department_name = department_name.replaceAll(" ", "-");
                return (
                  <div
                    className="col-sm-6 col-md-4 mb-lg-3 text-center mx-auto"
                    key={body_department.dept_id}
                  >
                    <Link
                      to={`/departments/${body_department.slug}`}
                      style={{
                        textDecoration: "none",
                        display: "inline-block",
                        // width: "100%",
                      }}
                      className="d-flex justify-content-center"
                    >
                      <div
                        className="doctor-list d-flex align-items-center departmentBg w-100 border-0 shadow-sm"
                        // style={{ height: "85px" }}
                      >
                        <div
                          className="card h-100 cardHover d-flex flex-row align-items-center justify-content-around w-100 py-3"
                          style={{ backgroundColor: "#F7F5EF" }}
                          onMouseEnter={() => setHoverId(body_department.id)}
                          onMouseLeave={() => setHoverId(null)}
                          onTouchStart={() => setHoverId(body_department.id)} // Works on mobile
                          onTouchCancel={() => setHoverId(null)} // Optional: Hide on touch end
                        >
                          {body_department.image ? (
                            <img
                              className="w-25"
                              src={
                                IMAGE_URL +
                                "DepartmentImage/" +
                                `${
                                  hoverId === body_department.id &&
                                  body_department.image_hover
                                    ? body_department.image_hover
                                    : body_department.image
                                }`
                              }
                              alt="avtars"
                              style={{ width: "45px", paddingLeft: "1rem" }}
                            />
                          ) : (
                            <img className="w-25" src={icon2} alt="Bitmap-3" />
                          )}
                          <div className="px-3 w-75">
                            <p
                              style={{
                                fontWeight: "700",
                                letterSpacing: "1px",
                              }}
                            >
                              {body_department.department_name}
                            </p>
                            <p
                              style={{
                                fontWeight: "700",
                                letterSpacing: "1px",
                              }}
                              className="text-capitalize "
                            >
                              Department
                            </p>
                          </div>
                        </div>

                        {/*<input type="radio" className="patient_user" name="body_dept_id" value={body_department.dept_id} onChange={this.handleChange} />*/}
                      </div>
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
        <BookAppointmentPopup
          bookAppointmentPopupClicked={bookAppointmentPopupClicked}
          setBookAppointmentPopupClicked={setBookAppointmentPopupClicked}
        ></BookAppointmentPopup>
      </div>
      <Route component={Footer} />
    </div>
  );
};
export default DepartmentsView;



// WEBPACK FOOTER //
// ./src/component/frontend/DepartmentsView.js